// Custom jQuery for Envy Shopify Theme, Designed and Coded by Nine (http://www.wearenine.com)

// Shopping Cart jQuery popup

$(document).ready(function () {
    $('.show-shopping-cart').click(function (e) {
        $("#minicart").slideToggle();
    });
});

// FlexSlider

$(window).load(function() {
  // The slider being synced must be initialized first
  $('#carousel').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    itemWidth: 285,
    itemMargin: 5,
    asNavFor: '#slider'
  });
   
  $('#slider').flexslider({
    animation: "slide",
    controlNav: false,
    animationLoop: false,
    slideshow: false,
    sync: "#carousel"
  });
});

// Mobile Browser Menu

$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// Pop-ups

jQuery('a.gallery').colorbox();